// Module
var code = "<a data-bind=\"text: $parent.GetValue(Name)\" href=\"#\"></a>";
// Exports
export default code;